import {Text3D} from "@react-three/drei";
import React from "react";
import fontData from 'src/components/3d/assets/AmazonEmberHeavy.json'

interface TextProps {
  height?: number;
  position?: number[];
  scale?: number;
  rotation?: number[];
}

export const EmberText3D = (props: React.PropsWithChildren<TextProps>) => {
  const { children } = props;
  return (
    // @ts-ignore
    <Text3D font={fontData} {...props}>
      {children}
      <meshStandardMaterial emissive={[1, 1, 1]} emissiveIntensity={.3} />
    </Text3D>
  )
}
